import React from 'react'

const SvgComponent = props => (
  <svg viewBox='0 0 179.33 190.04' {...props}>
    <defs />
    <g id='Layer_2' data-name='Layer 2'>
      <g id='Layer_1-2' data-name='Layer 1'>
        <path
          className='cls-1'
          d='M172.87 190a6.46 6.46 0 0 1-5.4-2.9 322.3 322.3 0 0 0-54.8-60.1 361.89 361.89 0 0 0-68.74-44.94 6.47 6.47 0 0 1 5.53-11.69A368 368 0 0 1 121 117.11 329.2 329.2 0 0 1 178.25 180a6.47 6.47 0 0 1-5.38 10z'
        />
        <path
          className='cls-1'
          d='M100.83 126.47a60.28 60.28 0 1 1 20.86-17.94q1.92 1.57 3.85 3.18 3.09 2.59 6 5.22a73.18 73.18 0 1 0-20.08 18.35q-1.66-1.44-3.35-2.87-3.62-3.07-7.28-5.94z'
        />
      </g>
    </g>
  </svg>
)

export default SvgComponent



// WEBPACK FOOTER //
// ./src/components/UI/Icons/TeqballIcon.js